import { render, staticRenderFns } from "./ForceNewsForm.vue?vue&type=template&id=b68c321e&scoped=true"
import script from "./ForceNewsForm.vue?vue&type=script&lang=js"
export * from "./ForceNewsForm.vue?vue&type=script&lang=js"
import style0 from "./ForceNewsForm.vue?vue&type=style&index=0&id=b68c321e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68c321e",
  null
  
)

export default component.exports